import { css, StyleDeclaration, StyleDeclarationValue } from 'aphrodite';
import { Avatar } from 'radix-ui';
import { FC } from 'react';
import { styleSheet } from './styles';

export interface AvatarProps {
	/** @deprecated Use styles instead. */
	styleDeclaration?: StyleDeclaration;
	imgSrc?: string;
	altText?: string;
	fallbackText?: string;
	smallText?: boolean;
	styles?: StyleDeclarationValue[];
}

export const Avatar2: FC<AvatarProps> = ({
	styleDeclaration: styleDeclaration,
	imgSrc,
	altText,
	fallbackText,
	smallText = false,
	styles = [],
}) => {
	return (
		<Avatar.Root className={css(styleSheet.root, styleDeclaration, ...styles)}>
			{imgSrc ? <Avatar.Image className={css(styleSheet.image)} src={imgSrc} alt={altText} /> : null}
			{!!fallbackText && (
				<Avatar.Fallback className={css(styleSheet.fallback, smallText && styleSheet.smallText, styleDeclaration)}>
					{fallbackText}
				</Avatar.Fallback>
			)}
		</Avatar.Root>
	);
};
